var u={album:"album-module_album__5XBrY",albumInfo:"album-module_albumInfo__w0kA5",audioIcon:"album-module_audioIcon__Adt4I",albumHover:"album-module_albumHover__uIn-G"};export{u as default};
